<div class="company-image__img-container">
  <img class="company-image__img" [alt]="companyName" onerror="this.src='/assets/svg/fallback.jpg'" [src]="image" *ngIf="image" />
  <div class="company-image__text" *ngIf="!image">
    <div class="company-image__text-inner">{{ companyName?.length ? companyName[0] : "" }}</div>
  </div>
</div>
